document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
    if (quickViewBtn) {
      setTimeout(() => {
        document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
      }, 2000);
    }
  });

  if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('product-form-holder--loaded')) {
            document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }
});
